import { COMMON } from '@sondermind/constants';
import { ISupportResources } from '../models/support-resources.interface';

export const enum SupportedLocales {
  AUSTRALIA = 'en-AU',
  AMERICA = 'en-US'
}

export const enum EmergencyServicesNumber {
  // NOTE: While some sources indicate that 112 is also a valid emergency number,
  // when in Australia, 112 will be redirected to 000, so it is the most general option
  AUSTRALIA = 'Triple Zero (000)',
  AMERICA = '911'
}

export const AMERICA_SUPPORT_RESOURCES: ISupportResources = {
  supportPhoneTherapyLink: COMMON.SUPPORT_PHONE_THERAPY_LINK,
  supportPhoneTherapyDisplay: COMMON.SUPPORT_PHONE_THERAPY_DISPLAY,
  supportPhoneTherapyDisplayWithDashes: COMMON.SUPPORT_PHONE_THERAPY_DISPLAY_DASHES,

  generalSupportPhoneLink: COMMON.SUPPORT_PHONE_GENERAL_LINK,
  generalSupportPhoneDisplay: COMMON.SUPPORT_PHONE_GENERAL_DISPLAY,

  supportPhoneNoMatchLink: COMMON.SUPPORT_PHONE_NO_MATCH_LINK,
  supportPhoneNoMatchDisplay: COMMON.SUPPORT_PHONE_NO_MATCH_DISPLAY,

  supportPhoneRematchLink: COMMON.SUPPORT_PHONE_REMATCH_LINK,
  supportPhoneRematchDisplay: COMMON.SUPPORT_PHONE_REMATCH_DISPLAY,

  supportEmail: COMMON.SUPPORT_EMAIL,

  emergencyServicesPhoneNumber: EmergencyServicesNumber.AMERICA,
  // NOTE: Not referencing the InfoLinks value, where this is also defined, because
  // InfoLinks is located in core which violates module boundaries
  emergencyHotlinesLink: 'https://www.sondermind.com/emergency-resources',
};

export const AUSTRALIA_SUPPORT_RESOURCES: ISupportResources = {
  supportPhoneTherapyLink: '',
  supportPhoneTherapyDisplay: '',
  supportPhoneTherapyDisplayWithDashes: '',

  generalSupportPhoneLink: '',
  generalSupportPhoneDisplay: '',

  supportPhoneNoMatchLink: '',
  supportPhoneNoMatchDisplay: '',

  supportPhoneRematchLink: '',
  supportPhoneRematchDisplay: '',

  supportEmail: COMMON.SAAS_SUPPORT_EMAIL,

  emergencyServicesPhoneNumber: EmergencyServicesNumber.AUSTRALIA,
  emergencyHotlinesLink: 'https://www.aihw.gov.au/suicide-self-harm-monitoring/resources/crisis-helplines-support-services',
};
